module.exports = __webpack_public_path__ + "static/img/img_4.e1e29d7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enterprise/images/img_4.webp
// module id = GWLr
// module chunks = 4